import axios from "axios";

export type ResourceGroup = {
   srcResourceId: string;
   type: string;
};

export type ResourceDomain = {
   name: string;
   description: string;
   role: string[];
   resourceGroups: ResourceGroup[];
};

export const fetchResourceDomain = (id: string): Promise<ResourceDomain> =>
   axios
      .get(`/idm/api/v1/im/rds/${id}`)
      .then((r) => r.data.rdInfo as ResourceDomain);
